module.exports = __webpack_public_path__ + "img/boy_010035.996b1745.png";